<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="$t('environmental-management.route-management.admin-template.history-routes')">
        </base-page-header>

        <v-row class="bg-white" style="border-radius: 7px">
            <v-col cols="12">
                <v-row class="bg-white mb-0 d-flex" style="border-radius: 7px">
                    <v-col cols="6" sm="8" :md="10" class="mb-0 pb-0">
                        <v-text-field
                        v-model="form.searchText"
                        class="search"
                        :label="$t('search')"
                        prepend-inner-icon="mdi-magnify"
                        @keypress.enter="searchForm"
                        @blur="searchForm"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="4" :md="2" class="mb-0 pb-0 d-flex align-end">
                        <v-btn
                            text
                            @click="openSearchAdvanced"
                            class="buttonAdvanced"
                            :class="{'active':searchState}"
                        >
                            {{$t('advanced-search')}}
                            <span v-show="searchState">
                                <img src="/images/_SVGs/menu-down.svg" class="ml-2" onload="SVGInject(this)" width="12" />
                            </span>
                            <span v-show="!searchState">
                                <img src="/images/_SVGs/chevron-double-right.svg" class="ml-2" onload="SVGInject(this)" width="12" />
                            </span>
                        </v-btn>

                    </v-col>

                    <v-col cols="12" class="mb-0 pb-0 pt-0">
                        <hr class="mb-0 mt-0">
                    </v-col>

                </v-row>

                <v-row class="bg-white d-flex filter-advenced" v-if="searchState" >

                    <v-col cols="12" :sm="3">
                        <v-row align="center">
                            <v-col cols="12">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        v-model="dateRangeText"
                                        :label="$t('environmental-management.route-management.history.request-date')"
                                        clearable
                                    ></v-text-field>
                                    </template>

                                    <v-date-picker
                                    v-model="form.dates"
                                    range
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="menu = false"
                                    >
                                        {{$t('cancel')}}
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.menu.save(date)"
                                    >
                                        {{$t('ok')}}
                                    </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" :sm="4">
                        <v-row align="center">
                            <v-col cols="4" sm="4">
                                <v-subheader>
                                    {{$t('environmental-management.route-management.history.nif-transporter')}}
                                </v-subheader>
                            </v-col>
                            <v-col cols="8" sm="6">
                                <v-text-field
                                    v-model="form.nifProdutor"
                                    :label="$t('environmental-management.route-management.history.nif-label')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" :sm="3">

                    </v-col>


                    <v-col cols="12" :sm="2" class="mt-3 text-md-right text-center mb-3 mb-sm-0">
                        <BaseButton :height='40' :width="100" @click="searchForm" class="float-none float-sm-right" style="background-color: #d6d6d6 !important;float: right;border-radius: 5px;">
                            {{$t('search')}} »
                        </BaseButton>
                    </v-col>

                </v-row>
                <v-data-table
                    :headers="headers"
                    :items="routes"
                    :page="page"
                    :pageCount="numberOfPages"
                    :options.sync="options"
                    :server-items-length="totalRecords"
                    :footer-props="{
                        showFirstLastPage: true,
                        'items-per-page-options': [10, 20, 50]
                    }"
                    class="data-table-history"
                    style="border-radius: 7px"
                >
                    <template v-slot:item.transportationStartDate="{ item }">
                        {{item.transportationStartDate | formatOnlyDate}}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <div class="d-flex align-center">
                            <span class="iconView" @click="viewRoute(item.routeId, item.name)">
                                <img src="/images/_SVGs/environmental/ver.svg" alt="voltar" onload="SVGInject(this)" width="20" height="20"/>
                            </span>

                            <v-tooltip bottom v-if="item.isNotCollected == 1">
                                <template v-slot:activator="{ on, attrs }">
                                    <a v-bind="attrs" v-on="on">
                                        <img src="/images/_SVGs/alert.svg" onload="SVGInject(this)" width="20" height="20" class="ml-2 info-alert"/>
                                    </a>
                                </template>
                                <span>{{$t('environmental-management.route-management.history.request-uncollected-order')}}</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row class="mt-8">
            <v-col cols="12" sm="2">
                <div class="back ml-4 mb-4" @click="$router.push({name: 'environmentalManagementRouteManagement'})">
                    <div><img src="/images/_SVGs/back.svg" :alt="$t('back')" onload="SVGInject(this)" /></div>
                    <div>{{$t('back')}}</div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { GetHistoryRoute } from '@services/b2b/environmental-management/RouterService';
    import BaseButton from "@components/shared/widgets/BaseButton.vue";
    import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";
    export default {
        components: {BasePageHeader, BaseButton},
        data(){
            return{
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.title'),
                        routerLinkName: 'environmentalManagementRouteManagement'
                    },
                    {
                        title: this.$t('environmental-management.route-management.view-history.title'),
                    }
                ],
                headers: [
                    {
                        text: this.$t('environmental-management.route-management.list-egars-headers.route-name'),
                        align: 'start',
                        value: 'name',
                    },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.transporter'), value: 'nameTranspoter' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.date'), value: 'transportationStartDate' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.producers'), value: 'totalProducers' },
                    { text: this.$t('environmental-management.route-management.list-egars-headers.kms'), value: 'kms' },
                    { text: '', value: 'action' },
                ],
                page: 1,
                numberOfPages:0,
                options: {
                    page: 1,
                    itemsPerPage: 10
                },
                itemsPerPage: 10,
                searchCount:0,
                totalRecords: 1,

                routes: [],

                searchState: false,
                searchText: '',
                dates:[],

                form:{
                    searchText:'',
                    dates:[],
                    nif: '',
                },


                menu: false,
                modal: false,
                date: '',
                filters: [],
                dateRangeText: ''
            }
        },
        watch: {
            "options.page": {
                handler() {
                    this.itemsPerPage = this.options.itemsPerPage
                    Object.assign(this.filters, {
                            pageSize: this.options.itemsPerPage,
                            currentPage: this.options.page
                        }
                    )
                    this.getHistory()

                },
            },
            "options.itemsPerPage": {
                handler() {
                    this.itemsPerPage = this.options.itemsPerPage
                    Object.assign(this.filters, {
                            pageSize: this.options.itemsPerPage,
                            currentPage: this.options.page
                        }
                    )
                    this.getHistory()

                },
            },
            "form.dates": {
                handler() {
                    if(this.form.dates){
                        this.dateRangeText = this.form.dates.join(' ~ ')
                    }
                },
            },
            dateRangeText: {
                handler: function(newValue, oldValue)  {
                    if(newValue == null){
                        this.form.dates = []
                    }
                },
            },
            searchCount:{
                handler() {
                this.options.page = 1
                },
            },
            deep: true,
        },
        methods:{
            viewRoute(routeId, name){
                this.$router.push({name: "environmentalManagementRouteManagementHistoryView", params: {id: routeId, name: name}})
            },
            openSearchAdvanced(){
                this.searchState = !this.searchState
            },
            searchForm(){
                this.filters = {
                    nif: this.form.nif ? this.form.nif : '',
                    createDateFrom: this.form.dates.length > 0?  this.form.dates[0]: '',
                    createDateTo: this.form.dates.length > 1?  this.form.dates[1]: '',
                    searchText: this.form.searchText,
                    pageSize: this.itemsPerPage,
                    currentPage: this.page,
                };

                this.searchCount = this.searchCount + 1

                this.getHistory()
            },
            getHistory(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                GetHistoryRoute(this.filters)
                .then(response => {
                    this.totalRecords = response.data.totalRecords
                    this.routes = response.data.result;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get GetHistoryRoute values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
        },
        created(){
            this.getHistory()
        }
    }
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

::v-deep table{
    thead {

        th{
            font-size: 13px !important;
            border: 0px solid rgb(224 224 224);
            height: 30px !important;
            background: $grey-light;
            color:rgb(113 113 113 / 60%) !important;
        }
    }
    tbody{
        td{
            border: 0px solid rgb(224 224 224);
            font-size: 13px !important;
            p{
                margin-bottom: 0;
                &.subTitle-table{
                    margin-top: 3px;
                    color: #c5c2c2;
                }
            }
        }
    }
}
.search{
    ::v-deep .v-label{
        margin-top: 0px !important;
    }
}
.iconView{
    border-radius: 50%;
    background: #f2f2f2;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.search{
    padding-top: 0;
    margin-top: 0;
}

.filter-advenced{
    margin-top: 0 !important;
    margin-bottom: 5px;
}

::v-deep svg.info-alert{
    path{
        fill: #ffcd00;
    }
}
</style>
